/* eslint-disable max-len */
export const SEO_CONFIG = {
	playbacpresse: {
		home: {
			title: 'Playbac Presse Digital: journaux jeunesse Le Petit Quotidien, Mon Quotidien, L\'actu, L\'éco et plus !',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		favoris: {
			title: 'Favoris - Playbac Presse Digital: journaux jeunesse Le Petit Quotidien, Mon Quotidien, L\'actu, L\'éco et plus !',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		exposes: {
			title: 'Fiches exposés Le Petit Quotidien, Mon Quotidien, L\'actu et L\'éco | Playbac Presse Digital',
			description: 'Toutes les fiches exposés de vos quotidiens jeunesse préférés classées par thématique: histoire, sciences, animaux, anglais et bien plus !'
		},
		exposesCateg: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		dossiers: {
			title: 'Dossiers d\'actualité Le Petit Quotidien, Mon Quotidien, L\'actu et L\'éco | Playbac Presse Digital',
			description: 'Retrouvez tous nos dossiers d\'actualité liés aux grands événements et aux célébrations historiques, classés par thématique. Consultez-les maintenant !'
		},
		login: {
			title: 'Se connecter pour accéder au contenu | Playbac Presse Digital',
			description: 'Connexion au compte utilisateur pour accéder à tout le contenu de vos journaux jeunesse préférés !'
		},
		contact: {
			title: 'Contactez-nous | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		'how-it-works':{
			title: 'Comment ça marche ? | Playbac Presse Digital',
			description: 'Tout ce qu\'il faut savoir pour accéder au cartable digital et consulter les journaux jeunesse Le Petit Quotidien, Mon Quotidien, L\'actu, L\'éco.'
		},
		'about-us':{
			title: 'Qui sommes-nous ? | Playbac Presse Digital',
			description: 'PlayBac est l\'inventeur des Incollables ainsi que des 3 seuls quotidiens pour enfants en Europe: Le Petit Quotidien, Mon Quotidien et L’ACTU qui comptent ensemble 150 000 abonnés.'
		},
		faq:{
			title: 'FAQ | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		legal: {
			title: 'Mentions légales | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		'vie-privee': {
			title: 'Vie privée | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		cookies: {
			title: 'Cookies | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		}
	},
	lepq: {
		name: 'Le Petit Quotidien',
		home:{
			title: 'Le Petit Quotidien, le seul journal d\'actualité pour les enfants de 6-10 ans',
			description: ''
		},
		exposes: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		exposesCateg: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		dossiersCateg: {
			title: 'Dossiers d\'actualité @journal@ | Playbac Presse Digital',
			description: 'Retrouvez tous nos dossiers d\'actualité liés aux grands événements et aux célébrations historiques, classés par thématique. Consultez-les maintenant !'
		},
		iosapp: {
			link: '380950225'
		}
	},
	aeco: {
		name: 'L\'Eco',
		home:{
			title: 'L\'ÉCO, le seul hebdo de décryptage de l\'actualité économique pour les jeunes, dès 15 ans.',
			description: 'Chaque vendredi, L\'ÉCO propose des brèves économiques françaises et étrangères, des chiffres et repères-clés décodés, et bien plus !'
		},
		exposes: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		exposesCateg: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		dossiersCateg: {
			title: 'Dossiers d\'actualité @journal@ | Playbac Presse Digital',
			description: 'Retrouvez tous nos dossiers d\'actualité liés aux grands événements et aux célébrations historiques, classés par thématique. Consultez-les maintenant !'
		}
	},
	actu: {
		name: 'L\'Actu',
		home:{
			title: 'L\'ACTU, le seul journal d\'actualité pour les jeunes, dès 13 ans',
			description: ''
		},
		exposes: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		exposesCateg: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés L\'actu classées par thématiques: histoire et géographie'
		},
		dossiersCateg: {
			title: 'Dossiers d\'actualité @journal@ | Playbac Presse Digital',
			description: 'Retrouvez tous nos dossiers d\'actualité liés aux grands événements et aux célébrations historiques, classés par thématique. Consultez-les maintenant !'
		},
		iosapp: {
			link: '1420135923'
		}
	},
	mquo: {
		name: 'Mon Quotidien',
		home:{
			title: 'Mon Quotidien, le seul journal d\'actualité pour les enfants de 10-14 ans',
			description: ''
		},
		exposes: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		exposesCateg: {
			title: 'Fiches exposés @journal@ | Playbac Presse Digital',
			description: 'Toutes les fiches exposés @journal@ classées par thématiques: histoire, sciences, géographie, culture générale, animaux, instruction civique.'
		},
		dossiersCateg: {
			title: 'Dossiers d\'actualité @journal@ | Playbac Presse Digital',
			description: 'Retrouvez tous nos dossiers d\'actualité liés aux grands événements et aux célébrations historiques, classés par thématique. Consultez-les maintenant !'
		}
	},
	week: {
		name: 'My Weekly',
		home:{
			title: 'My Weekly',
			description: ''
		}
	},
	mwne: {
		name: 'My Weekly News',
		home:{
			title: 'My Weekly News',
			description: ''
		}
	},
	mlwk: {
		name: 'My Little Weekly',
		home:{
			title: 'My Little Weekly',
			description: ''
		}
	},
	mlne: {
		name: 'My Little Weekly News',
		home:{
			title: 'My Little Weekly News',
			description: ''
		}
	},
	woch: {
		name: 'Meine Woche',
		home:{
			title: 'Meine Woche',
			description: ''
		}
	},
	sema: {
		name: 'Mi Semanal',
		home:{
			title: 'Mi Semanal',
			description: ''
		}
	},
	mquovideo: {
		name: 'Mon Quotidien Video',
		home:{
			title: 'Mon Quotidien Video',
			description: ''
		}
	},
	actuvideo: {
		name: 'L\'actu Video',
		home:{
			title: 'L\'actu Video',
			description: ''
		}
	},
	mwjp: {
		name: 'My Weekly Japanese',
		home:{
			title: 'MY WEEKLY - 中高生のお子様を対象に英語圏の主なニュースをお届けする週刊英字新聞',
			description: '毎週水曜日10分だけ英字新聞をご家族で読んでみませんか？英国の新聞記事からセレクションした記事をお届けします。'
		},
		contact: {
			title: '購読ページに行くためにログインする | My Weekly',
			description: '中高生のための唯一のデジタル版新聞。サイト上でアーカイブにもアクセスできます。購読する, インターネットで購読手続きをする, 英語'
		},
		'how-it-works':{
			title: 'アクセス方法 | My Weekly',
			description: 'My Weekly PDF版とオーディオにアクセスするには 購読する, インターネットで購読手続きをする, 英語'
		},
		'about-us':{
			title: '会社紹介 | My Weekly',
			description: 'PlayBac社はIncollablesという教材を作り、ヨーロッパで唯一の子供向けの日刊紙 Le Petit Quotidien、Mon Quotidien、L’ACTU を発行し、購読者は150 000 人に上ります。'
		},
		faq:{
			title: 'FAQ | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		legal: {
			title: 'リーガル・インフォメーション | My Weekly',
			description: '中高生のための唯一のデジタル版新聞。サイト上でアーカイブにもアクセスできます。'
		},
		'fan-mai-gui-yue': {
		title: 'リーガル・インフォメーション | My Weekly',
		description:
			'中高生のための唯一のデジタル版新聞。サイト上でアーカイブにもアクセスできます。'
		}
	},
	mwde: {
		name: 'My Weekly Deutsch',
		home: {
			title: 'MY WEEKLY - Das Wichtigste des aktuellen Weltgeschehens der Woche auf Englisch für Kinder',
      description: 'Jeden Mittwoch 10 Minuten Nachrichten auf Englisch für die ganze Familie ab 13 Jahren! Geschrieben von einer britischen Redaktion.'
		},
		contact: {
			title: 'My Weekly',
			description: ''
		},
		'how-it-works':{
			title: 'My Weekly',
			description: ''
		},
		'about-us':{
			title: 'My Weekly',
			description: ''
		},
		faq:{
			title: 'FAQ | Playbac Presse Digital',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		legal: {
			title: 'My Weekly',
			description: ''
		}
	},
	clfy: {
		name: 'Clarify',
		home: {
			title: 'Clarify',
      		description: 'Clarify'
		},
		contact: {
			title: 'Clarify',
			description: ''
		},
		'how-it-works':{
			title: 'Clarify',
			description: ''
		},
		'about-us':{
			title: 'Clarify',
			description: ''
		},
		faq:{
			title: 'Clarify',
			description: 'Une seule plateforme digitale offrant tous nos journaux pour écoliers, collégiens et lycéens, avec archives, fiches exposés et dossiers d\'actu. Consultez maintenant !'
		},
		legal: {
			title: 'Clarify',
			description: ''
		}
	},
	mljp: {
		name: 'My Little Weekly',
		home: {
			title: 'MY LITTLE WEEKLY - 世界の選りすぐりのニュースを発信する週刊新聞、英語を学ぶ子供達に。',
      description: '13歳以上のお子様がいるご家庭を対象にした、毎週水曜発行の10分で読める英字新聞。イギリス人による編集。'
		}
	}
};
